import { combineReducers } from 'redux'
import gemstoneReducers from './reducer'
const RootReducer = combineReducers({
    gemstone: gemstoneReducers,
    
})
export default RootReducer